import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StreamMenuComponent } from './stream-menu.component'
import { RouterModule } from '@angular/router'

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [StreamMenuComponent],
  exports: [StreamMenuComponent],
  providers: [],
})
export class StreamMenuModule {}
